import { useRef, useState } from "react";
import { Play } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "@/i18n";

const VIDEO_SRC = "/api/files/capitalstone/uploads/53b91ac7-246d-4073-b87c-f851361ed5c6.mp4";
const POSTER_SRC = "/api/files/capitalstone/uploads/ac2faa0d-6e5d-4737-93c4-a8ec9c1ce3b8.jpg";

export const VideoSection = () => {
  const { t } = useLang();
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      v.play();
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  return (
    <section id="dietro-le-quinte" data-testid="video-section" className="py-20 lg:py-32 px-4 sm:px-8 lg:px-16 max-w-5xl mx-auto border-t border-amber-500/10">
      <Reveal>
        <p className="text-xs tracking-[0.35em] uppercase font-mono text-amber-400/90 mb-4">{t("vid_overline")}</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-zinc-100 max-w-2xl mb-12">
          {t("vid_h1")} <span className="italic text-gold">{t("vid_h2")}</span>
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="relative gold-frame border border-amber-500/15 bg-black overflow-hidden group" data-testid="video-frame">
          <video
            ref={videoRef}
            src={VIDEO_SRC}
            poster={POSTER_SRC}
            controls={playing}
            playsInline
            preload="none"
            onClick={toggle}
            onEnded={() => setPlaying(false)}
            className="w-full aspect-video object-cover cursor-pointer"
          />
          {!playing && (
            <button
              data-testid="video-play-btn"
              onClick={toggle}
              aria-label="Play"
              className="absolute inset-0 flex items-center justify-center bg-black/30 transition-colors duration-500 hover:bg-black/15"
            >
              <span className="w-20 h-20 rounded-full bg-[#D4AF37] text-[#0A0A0C] flex items-center justify-center shadow-[0_0_50px_rgba(212,175,55,0.45)] transition-transform duration-500 group-hover:scale-110">
                <Play size={30} className="ml-1.5" fill="currentColor" />
              </span>
            </button>
          )}
        </div>
      </Reveal>
    </section>
  );
};
